import React, { Component } from 'react'
import { Row, Col, Alert, Button, Input, DatePicker, message } from 'antd'
import AdminMapInput from './AdminMapInput'
import moment from 'moment'

const { TextArea } = Input
const dateFormat = 'YYYY/MM/DD'

class AdminProgramsForm extends Component {

    constructor(props) {
        super(props)
        this.updateForm = this.updateForm.bind(this)
        this.state = Object.assign({}, this.props.data)
    }

    componentWillReceiveProps(nextProps) {
        this.setState(nextProps.data)
    }

    addLocal(local) {
        var state = Object.assign({}, this.state);
        state.locals.push(local);
        this.setState(state);
    }

    updateMarkerCoords(id, coords) {
        var state = Object.assign({}, this.state);
        state.locals.map(m => {
            if (m.id === id) {
                m.x = coords[0];
                m.y = coords[1];
            }
            return m;
        });
        this.setState(state);
    }

    clearLocals() {
        var state = Object.assign({}, this.state);
        state.locals.splice(0, state.locals.length);
        this.setState(state);
    }

    updateForm(field, value) {
        const formData = this.state
        formData[field] = value
        this.setState(formData)
    }

    save() {
        // Validate
        if (!this.state.locals.length) message.error('O marcador é obrigatório');
        else this.props.storeItem(this.state)
    }

    render() {
        return (
            <Row>
                <Col span={24}>
                    <form method="post" onSubmit={(e) => {
                        e.preventDefault()
                        this.save()
                    }}>
                        <input type="hidden" ref="id" value={this.state.id} />

                        <Row>
                            <Col xs={24} sm={6}></Col>
                            <Col xs={24} sm={14}>
                                <legend>{this.state.id ? 'Alterar Programa' : 'Criar Novo Programa'}</legend>
                            </Col>
                        </Row>

                        <div className="ant-row ant-form-item">
                            <div className="ant-form-item-label ant-col-xs-24 ant-col-sm-6">
                                <label htmlFor="label" className="ant-form-item-required" title="Título">
                                    Título
                                </label>
                            </div>
                            <div className="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-14">
                                <input id="nome"
                                    type="text"
                                    required="required"
                                    className="ant-input"
                                    value={this.state.titulo}
                                    ref="titulo"
                                    onChange={(e) => this.updateForm('titulo', e.target.value)}
                                />
                            </div>
                        </div>

                        <div className="ant-row ant-form-item">
                            <div className="ant-form-item-label ant-col-xs-24 ant-col-sm-6">
                                <label htmlFor="descricao" className="ant-form-item" title="Descrição">Descrição</label>
                            </div>
                            <div className="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-14">
                                <div className="ant-form-item-control ">
                                    <TextArea id="descricao"
                                        rows={3}
                                        value={this.state.descricao}
                                        onChange={(e) => this.updateForm('descricao', e.target.value)} />
                                </div>
                            </div>
                        </div>

                        <div className="ant-row ant-form-item">
                            <div className="ant-form-item-label ant-col-xs-24 ant-col-sm-6">
                                <label htmlFor="label" className="ant-form-item" title="URL">
                                    URL
                                </label>
                            </div>
                            <div className="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-14">
                                <input id="url"
                                    type="text"
                                    className="ant-input"
                                    value={this.state.url}
                                    ref="url"
                                    onChange={(e) => this.updateForm('url', e.target.value)}
                                />
                            </div>
                        </div>

                        <div className="ant-row ant-form-item">
                            <div className="ant-form-item-label ant-col-xs-24 ant-col-sm-6">
                                <label htmlFor="data_inicio" className="ant-form-item-required" title="Data e Hora">
                                    Data de Início
                                </label>
                            </div>
                            <div className="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-14" id="issueDateWrapper">
                                <DatePicker value={this.state.data_inicio ? moment(this.state.data_inicio, dateFormat) : null} format={dateFormat}
                                    onChange={(date, dateStr) => {this.updateForm('data_inicio', dateStr)}}
                                />
                            </div>
                        </div>

                        <div className="ant-row ant-form-item">
                            <div className="ant-form-item-label ant-col-xs-24 ant-col-sm-6">
                                <label htmlFor="data_fim" className="ant-form-item" title="Data de Fim">
                                    Data de Fim
                                </label>
                            </div>
                            <div className="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-14" id="issueDateWrapper">
                                <DatePicker value={this.state.data_fim ? moment(this.state.data_fim, dateFormat) : null} format={dateFormat}
                                    onChange={(date, dateStr) => {this.updateForm('data_fim', dateStr)}}
                                />
                            </div>
                        </div>

                        <AdminMapInput 
                            mapCenter={this.state.center}
                            mapZoom={this.state.zoom}
                            onUpdateAddress={value => this.updateForm('address', value)}
                            onUpdateCenter={value => this.updateForm('center', value)}
                            onUpdateZoom={value => this.updateForm('zoom', value)}
                            markers={this.state.locals || []}
                            addLocal={this.addLocal.bind(this)}
                            updateMarkerCoords={this.updateMarkerCoords.bind(this)}
                            clearLocals={this.clearLocals.bind(this)}
                            address={this.state.address}
                        />

                        <Row>
                            <Col xs={24} sm={6}></Col>
                            <Col xs={24} sm={14}>
                                <Alert className={this.props.complete && this.props.error ? '' : 'hidden'}
                                    message="Erro"
                                    description={this.props.error}
                                    type="error"
                                    showIcon
                                />
                                <Alert className={this.props.complete && !this.props.error ? '' : 'hidden'}
                                    message="Sucesso!"
                                    description="O programa foi guardado com sucesso."
                                    type="success"
                                    showIcon
                                />
                            </Col>
                        </Row>

                        <Row>
                            <Col xs={24} sm={6}></Col>
                            <Col xs={24} sm={14}>
                                <div style={{borderTop: '2px solid gray', marginTop: '16px', paddingTop: '8px'}}>
                                    <button type="submit" className="ant-btn ant-btn-primary" style={{float: 'right'}}>
                                        <i className="anticon anticon-save"></i>
                                        <span>Guardar</span>
                                    </button>
                                    <Button type="danger" onClick={(e) => this.props.history.push('/admin/programs')}>
                                        Cancelar
                                    </Button>
                                </div>
                            </Col>
                        </Row>

                    </form>
                </Col>
            </Row>
        )
    }
}

export default AdminProgramsForm;



// WEBPACK FOOTER //
// ./src/components/AdminProgramsForm.js